import type { ReactElement } from 'react';
import { Box, Tooltip } from '@mui/material';

interface LayersRowActionTooltipProps {
  title: string;
  /** The row's icon button. It may be natively `disabled` (a busy row), which MUI's Tooltip cannot listen to by itself. */
  children: ReactElement;
}

/**
 * Tooltip for a row action that can be disabled. MUI attaches its hover/focus listeners to the child and
 * warns when that child is a `disabled` button (no events fire, so the tooltip would never show), so the
 * listeners sit on a wrapping `span`. The title describes the button (`describeChild`), it does not rename
 * it: the button keeps its own `aria-label`, and the wrapper is not announced as a second control.
 */
export function LayersRowActionTooltip({ title, children }: LayersRowActionTooltipProps) {
  return (
    <Tooltip title={title} describeChild>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        {children}
      </Box>
    </Tooltip>
  );
}
